module.exports = __webpack_public_path__ + "img/nls-logo.c9e0d90f.jpg";